import { atom } from "recoil";
import { IVendorInvoiceDetails } from "../types";

export const showInvoice = atom<true | false>({
  key: "showInvoice",
  default: false,
});
export const pdfFileState = atom({
  key: "pdfFileState",
  default: null,
});
export const pdfData = atom({
  key: "pdfData",
  default: null,
});
export const isLoadingState = atom({
  key: "isLoadingState",
  default: false,
});
export const isAddState = atom({
  key: "isAddState",
  default: false,
});
export const isEditState = atom({
  key: "isEditState",
  default: false,
});
export const rowForEditData = atom<IVendorInvoiceDetails | undefined>({
  key: "rowForEditData",
  default: undefined,
});
export const getDataById = atom({
  key: "getDataById",
  default: undefined,
});
export const isAddInvoice = atom({
  key: "isAddInvoice",
  default: false,
});

export const defaultPendingSearchData = atom({
  key: "defaultPendingSearchData",
  default: {
    OfficeId: 0,
    ServiceAccountNo: "",
    BatchNo: 0,
    DateCreatedFrom: "",
    DateCreatedTo: "",
    Status: "Unverified",
    StoreNumber: "",
  },
});

export const voidedData = atom({
  key: "voidedData",
  default: undefined,
});

export const addFromVoidedState = atom({
  key: "addFromVoidedState",
  default: false,
});

export const hasExistingState = atom({
  key: "hasExistingState",
  default: false,
});

export const officeVendorOptsData = atom({
  key: "officeVendorOptsData",
  default: undefined,
});

export const isFromRediInvoice = atom<true | false>({
  key: "isFromRediInvoice",
  default: false,
});

export const defaultSubmittedSearchData = atom({
  key: "defaultSubmittedSearchData",
  default: {
    StoreNumber: "",
    ServiceAccountNo: "",
    BatchNo: 0,
    TaxId: "",
    DateCreatedFrom: "",
    DateCreatedTo: "",
    Status: "Approved",
    InvoiceNumber: "",
  },
});

export const defaultCompletedSearchData = atom({
  key: "defaultCompletedSearchData",
  default: {
    StoreNumber: "",
    ServiceAccountNo: "",
    BatchNo: 0,
    TaxId: "",
    DateCreatedFrom: "",
    DateCreatedTo: "",
    Status: "Completed",
    InvoiceNumber: "",
    BillRefNumber: "",
  },
});

export const defaultVoidedSearchData = atom({
  key: "defaultVoidedSearchData",
  default: {
    StoreNumber: "",
    ServiceAccountNo: "",
    BatchNo: 0,
    TaxId: "",
    DateCreatedFrom: "",
    DateCreatedTo: "",
    Status: "Voided",
    InvoiceNumber: "",
    BillRefNumber: "",
  },
});
export const invoiceDescription = atom({
  key: "invoiceDescription",
  default: {
    AccountNumber: "",
    BankAccount: "",
    BillDueDate: "",
    ServiceDueDate: "",
    DueDate: "",
    AutoPay: "",
  },
});

export const pendingData = atom({
  key: "pendingData",
  default: undefined,
});
